import { create } from "zustand"

export const barChartStore = create((set) => ({
  xAxis: [],
  series: [],
  setChart: (id = "전체", units, customColors) => {
    const data = units.map((unit) => ({
      value: unit.usage,
      unit_id: unit.unit_id,
      apt_size: unit.apt_size,
      itemStyle: {
        borderRadius: [4, 4, 0, 0],
        color: customColors[unit.apt_size]
      }
    }))

    const series = [
      {
        name: id,
        type: "bar",
        data
      }
    ]

    const xAxis = units.map((unit) => {
      const [dong, ho] = unit.unit_id.split("-")
      return `${dong}-${ho}`
    })
    set({ series, xAxis })
  },

  reset: () => {
    set({
      xAxis: [],
      series: []
    })
  }
}))
